'use strict'

import Helper from '@/utils/helper'
import ApiResponseCode from '@/app/service/api/api-response-code'

class ApiBaseResponse {
  constructor ({ code, description, message }) {
    const responseCode = ApiResponseCode.fromValue(code)
    this.code = Helper.getValue(responseCode, ApiResponseCode.UNKNOWN)
    this.description = Helper.getValue(description)
    this.message = Helper.getValue(message)
  }

  getDescription () {
    return this.description
  }

  getMessage () {
    return this.message
  }

  isAccessDenied () {
    return this.code.isAccessDenied()
  }

  isKnown () {
    return !this.code.isUnknown()
  }

  toString () {
    return 'ApiBaseResponse{' +
      'code=' + '\'' + this.code + '\'' +
      ', description=' + '\'' + this.description + '\'' +
      ', message=' + '\'' + this.message + '\'' +
      '}'
  }
}

export default ApiBaseResponse
